/**
 * Avaliable blog category:
 * Gadget
 * Tips
 * Hiburan
 * Gaya Hidup
 * Literasi Keuangan
 * Pembiayaan Konsumen
 * Terpopuler
 */
export const blogCategory = [
  {
    name: "Terbaru",
    codename: "terbaru",
    taxonomy: "",
  },
  {
    name: "Terpopuler",
    codename: "terpopuler",
    taxonomy: "Terpopuler",
  },
  {
    name: "Literasi Keuangan",
    codename: "literasi_keuangan",
    taxonomy: "Literasi Keuangan",
  },
  {
    name: "Pembiayaan Konsumen",
    codename: "pembiayaan_konsumen",
    taxonomy: "Pembiayaan Konsumen",
  },
  {
    name: "Gadget",
    codename: "gadget",
    taxonomy: "Gadget",
  },
  {
    name: "Hiburan",
    codename: "hiburan",
    taxonomy: "Hiburan",
  },
  {
    name: "Gaya Hidup",
    codename: "gaya_hidup",
    taxonomy: "Gaya Hidup",
  },
  {
    name: "Tips",
    codename: "tips",
    taxonomy: "Tips",
  },
];

export const BlogTitle = {
  terbaru: {
    title: "Terbaru",
    slug: "terbaru",
  },
  terpopuler: {
    title: "Terpopuler",
    slug: "terpopuler",
  },
  literasi_keuangan: {
    title: "Literasi Keuangan",
    slug: "literasi-keuangan",
  },
  pembiayaan_konsumen: {
    title: "Pembiayaan Konsumen",
    slug: "pembiayaan-konsumen",
  },
  gadget: {
    title: "Gadget",
    slug: "gadget",
  },
  hiburan: {
    title: "Hiburan",
    slug: "hiburan",
  },
  gaya_hidup: {
    title: "Gaya Hidup",
    slug: "gaya-hidup",
  },
  tips: {
    title: "Tips",
    slug: "tips",
  },
};
